import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  computed,
  DestroyRef,
  ElementRef,
  inject,
  Injector,
  input,
  viewChild,
  ViewEncapsulation,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { PurifyPipe } from 'src/app/features/common/pipes/purify/purify.pipe';
import { operationExtension } from 'src/app/features/mce-editor/extensions/operation/operation.extension';
import { registerExtensionsRender } from 'src/app/features/mce-editor/registerExtensions';

@Component({
  imports: [CommonModule, PurifyPipe],
  selector: 're-message-content',
  encapsulation: ViewEncapsulation.None,
  template: `<div
    class="message-content re-prose"
    #contentElement
    [class.preview]="preview()"
    [innerHTML]="_content() ?? '' | purify"
  ></div>`,
  styleUrls: ['./message-content.component.scss'],
})
export class MessageContentComponent implements AfterViewInit {
  content = input<string | undefined | null>();
  _content = computed(() =>
    this.preview()
      ? this.content()?.replaceAll('&nbsp;', '').trim()
      : this.content()
  );
  preview = input<boolean>(false);
  contentElement = viewChild<ElementRef<HTMLDivElement>>('contentElement');

  contentChange = toObservable(this.content);
  injector = inject(Injector);

  ngAfterViewInit() {
    registerExtensionsRender(
      this.contentElement,
      this.contentChange,
      this.preview,
      this.injector,
      [operationExtension.render]
    );
  }
}
